import React from "react"
import CustomTable from "../../components/CustomTable";
import { abuseUpdateApprovedAndUnapproved, addAbuseWordName, editAbuseWordName, getAllAbuseWords } from "../../services/ApiServices";
import { ApprovedAndUnApprovedBtn } from "../../components/ApprovedAndUnApprovedBtn";
import { EditButton } from "../../components/masterDataForm/EditButton";
import { AddButton } from "../../components/masterDataForm/AddButton";
import AddMasterForm from "../../components/masterDataForm/AddMasterForm";
import EditMasterForm from "../../components/masterDataForm/EditMasterForm";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

const AbuseWord = () => {

    const dispatch = useDispatch();
    const abuseWordInfo = useSelector((state) => state?.getAllAbuseWords?.abuseWord);
    
    const [showAbuseWord, setAbuseWordShow] = React.useState(false);
    const [showAddAbuseWord, setAddAbuseWordShow] = React.useState(false);
    const [abuseWordValName, setAbuseWordValName] = React.useState();


    React.useEffect(() => {
        const fetchUsers = async () => {
            try {
                const res = await getAllAbuseWords();
                dispatch({ type: "GET_ALL_ABUSE_WORDS", payload: res.data?.data });
            } catch (error) {
                console.error("Error fetching users:", error);
            }
        };
        fetchUsers();
    }, [dispatch]);

    const addAbuseWordHandle = async (abuseWordName) => {
        try {
            const addAbuseWordNames = await addAbuseWordName(abuseWordName);
            if(addAbuseWordNames.status === 200) {
                dispatch({ type: 'ADD_ABUSE_WORDS_NAME', payload: addAbuseWordNames.data?.data})
                toast.success(addAbuseWordNames.data?.message)
            }
        } catch (error) {
            toast.error(error.response?.data?.message)
        }
    };

    const editAbuseWordNameHandle = async (abuseWord) => {
        try {
            const abuseWordPayload = {
                abuseId: abuseWord?.statusId,
                name: abuseWord?.name
            }
            const editAbuseWordNames = await editAbuseWordName(abuseWordPayload);
            if(editAbuseWordNames.status === 200) {
                dispatch({ type: 'UPDATE_ABUSE_WORDS_NAME', payload: editAbuseWordNames.data?.data})
                toast.success(editAbuseWordNames.data?.message)
            }
        } catch (error) {
            toast.error(error.response?.data?.message)
        }

    };

    const abuseApprovedAndUnApproved = async (abuseId) => {
        try {
            const approvedAndUnapprovedStatus = await abuseUpdateApprovedAndUnapproved(abuseId);
            if(approvedAndUnapprovedStatus.status === 200) {
                dispatch({ type: 'UPDATE_ABUSE_WORDS_STATUS', payload: approvedAndUnapprovedStatus.data?.data})
                toast.success(approvedAndUnapprovedStatus.data?.message)
            }
        } catch (error) {
            toast.error(error.response?.data?.message)
        }

    };

    const colDefs = [
            { field: "name", flex: 2, headerName: 'Name' },
            { field: "isApproved", flex: 2, headerName: 'Status', cellRenderer: (val) => {
            return ( <ApprovedAndUnApprovedBtn status={val?.data?.isApproved} statusId={val.data._id} handleApprovedAndUnAprooved={abuseApprovedAndUnApproved} /> )
            }
        },
            { field: '_id', filter: false, flex: 2, headerName: 'Action', cellRenderer: (val) => ( <EditButton  name={val.data.name} statusId={val.data._id} hadnleEditName={setAbuseWordValName} handleEditBtn={setAbuseWordShow} />) }
        ];

    return(
        <React.Fragment>
            <div className="aside-heading"><h3>Abuse Words</h3></div>
            <AddButton formName="Abuse Words"  handleAddBtn={setAddAbuseWordShow} />
            <CustomTable colDefs={colDefs} rowData={abuseWordInfo} />
            <AddMasterForm formName="Abuse Words" addMasterData={addAbuseWordHandle} showAddForm={showAddAbuseWord} setShowAddForm={setAddAbuseWordShow}/>
            <EditMasterForm formName="Abuse Words" editMasterDataName={abuseWordValName} editMasterData={editAbuseWordNameHandle} showEditForm={showAbuseWord} setShowEditForm={setAbuseWordShow}/>
        </React.Fragment>
    )
};
export default AbuseWord;